import axios from "axios";
import { search } from "@/api";

export const typeMap = {
  competency: "Оценочные материалы",
  "competency/doc": "Документы оценочных материалов",
  "regulation/doc": "Нормативные документы",
  "training-center": "Список ЦПДЭ",
  "manager-competency": "Менеджеры компетенций",
  faq: "FAQ"
};

export const linkMap = {
  competency: "/competencies",
  "regulation/doc": "/regulations",
  "training-center": "/training-centers",
  "manager-competency": "/managers",
  faq: "/faq"
};

export const searchMixin = {
  methods: {
    search() {
      if (this.query.length && !this.$refs.suggest.hovered) {
        this.$router.push({ path: "search", query: { k: this.query } });
      }
    },
    onSuggestSelect(value) {
      if (value.type === "competency" && value.parent) {
        this.$router.push({
          name: "competence",
          params: { competenceId: value.parent.guid, categoryId: value.guid }
        });
      }
      if (value.type === "competency" && !value.parent) {
        this.$router.push({
          name: "competencies",
          params: { title: value.title }
        });
      }
      if (value.type === "regulation/doc") {
        this.$router.push({
          path: "regulations",
          query: { docId: value.guid }
        });
      }
      if (value.type === "competency/doc") {
        this.$router.push({
          name: "competence",
          params: {
            competenceId: value.parent.parent.guid,
            categoryId: value.parent.guid
          }
        });
      }
      if (value.type === "manager-competency") {
        this.$router.push({
          path: "managers",
          query: { title: value.title }
        });
      }
      if (value.type === "training-center") {
        this.$router.push({
          path: "training-centers",
          query: { title: value.title }
        });
      }
      if (value.type === "faq") {
        this.$router.push({
          path: "faq",
          query: { guid: value.guid }
        });
      }
    },
    async onInput() {
      if (this.query) {
        const response = await search({ k: this.query });
        this.list = response.data;
      }
    }
  }
};

export function errorInterceptor() {
  axios.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      if (error.response && error.response.status > 299) {
        this.$alert.danger({
          message: "Произошла ошибка. Попробуйте перезагрузить страницу.",
          duration: 2000
        });
      }
      return Promise.reject(error);
    }
  );
}
